export const STATUS = {
  RESOLVED: 'resolved',
  REJECTED: 'rejected',
  IDLE: 'idle',
  PENDING: 'pending',
}